enum ActivityComponentType {
  SLIDER = "slider",
  PAGINATED = "paginated",
  LIST = "list"
}
export default ActivityComponentType;
